import { Book, CalendarMonth, ImportContacts, Schedule, Task } from "@mui/icons-material"

const routes = {
    main: {
        path: "/",
    },
    login: {
        path: "/login"
    },
    lessonLogBook: {
        path: "/lesson_logbook",
        name: "Занятия",
        icon: ImportContacts
    },
    groupSubjectLoogBook: {
        path: "/group_subject_loogbook",
        name: "Сводный журнал",
        icon: Book
    },
    studentLogBook: {
        path: "/student_loogbook",
        name: "Успеваемость",
        icon: Book
    },
    studentLessons: {
        path: "/student_lessons",
        name: "Занятия",
        icon: Task,
    },
    timetable: {
        path: "/timetable",
        name: "Расписание",
        icon: Schedule,
    },
    plans: {
        path: "/plans",
        name: "Планы",
        icon: CalendarMonth,
    }
}

export default routes